import { BoxRadius, Spacing } from '@genial/design-tokens';
import { Skeleton } from 'native-base';
import React from 'react';

import { TableContent, TableContentItemColumn } from '../../../../../../components/TableContent';
import { getFlex } from '../../utils';

export const WithdrawalLoadingDesktop: React.FC = () => {
  return (
    <TableContent
      direction="row"
      space={Spacing['stack.nano']}
      py={Spacing['stack.xxs']}
      px={Spacing['inline.xxxs']}
      spaceX={Spacing['inline.xxxs']}>
      <TableContentItemColumn flex={getFlex(0)}>
        <Skeleton height={Spacing['inset.xs']} width="100%" borderRadius={BoxRadius.sm} />
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(1)}>
        <Skeleton height={Spacing['inset.xs']} width="100%" borderRadius={BoxRadius.sm} />
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(2)}>
        <Skeleton height={Spacing['inset.xs']} width="100%" borderRadius={BoxRadius.sm} />
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(3)}>
        <Skeleton height={Spacing['inset.xs']} width="100%" borderRadius={BoxRadius.sm} />
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(4)}>
        <Skeleton height={Spacing['inset.xs']} width="100%" borderRadius={BoxRadius.sm} />
      </TableContentItemColumn>
    </TableContent>
  );
};
